import { useEffect, useState, useRef, useCallback } from 'react';
import { UpdateLeadStage, appKanbanUserList, appSubmission, getCompanies, getLabel, getOpportunitiesListByStage, getPipelines, getSoftwareUsers, registeredUserList } from '../../utils/urls';
import axios from '../../utils/axios';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AppsTable from '../../components/apps/appsTable';
import AppSectionList from '../../components/apps/appsKanban/AppSectionList';
import FlexComponent from '../../components/FlexComponent';
import './appLeads.css';
import useDebounce from '../../components/apps/appsKanban/hooks/useDebounce';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import ArchivedAppsTable from '../../components/apps/ArchivedAppsTable';
import adminLogo from '../../Images/admin_img.jpg';
import { CancelToken } from 'axios';
import useWebSocket from 'react-use-websocket';

const RealTimeAppsKanban = () => {
    const { pipelineId } = useParams();
    const { table } = useParams();

    const isSuperuser = useSelector((state) => state.user.isSuperuser);
    const image = useSelector((state) => state.user.image);
    const userId = useSelector((state) => state.user.userId);

    const [loading, setLoading] = useState(false);
    const [isLastCommunicationFilter, setIsLastCommunicationFilter] = useState(false);
    const cancelTokenRef = useRef(null);
    const toast = useRef(null);
    const [isMounted, setIsMounted] = useState(false);

    const [boardSections, setBoardSections] = useState({
        "⏲️ Waiting/Follow Up": [],
        "🤳 Self-Serve Quick App": [],
        "📃✨ New Application": [],
        "🤖 Auto Doc Request": [],
        "🔥 Prequalified Awaiting Docs": [],
        "📄 Docs in - Active Client": [],
        "✅ Preapproved": [],
        "🛒Shopping": [],
        "📈 Refi": [],
        "✅ Active Loan": []
    });
    const [pipeline, setPipeline] = useState('');
    const [stageIds, setStageIds] = useState({});
    const [stageWatchers, setStageWatchers] = useState({});
    const [stageAppCounts, setStageAppCounts] = useState({});
    const [usersList, setUsersList] = useState([]);
    const [registeredUsersList, setRegisteredUsersList] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [softwareUsers, setSoftwareUsers] = useState([]);
    const [selectedApplicationByUsers, setSelectedApplicationByUsers] = useState([]);
    const [labels, setLabels] = useState([]);
    const [selectedLabels, setSelectedLabels] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [selectedCompanies, setSelectedCompanies] = useState([]);
    const [selectedLanguages, setSelectedLanguages] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [dateRange, setDateRange] = useState([]);
    const [dueDateRange, setDueDateRange] = useState([])
    const [lastCommunicationRange, setLastCommunicationRange] = useState([]);
    const [dueDateRangeString, setDueDateRangeString] = useState('')
    const [lastCommunicationString, setLastCommunicationString] = useState('');
    const [incomeRangeValue, setIncomeRangeValue] = useState([0, 2000000]);
    const [creditRangeValue, setCreditRangeValue] = useState([0, 1000]);
    const [savingsRangeValue, setSavingsRangeValue] = useState([0, 2000000]);
    const [appScoreValue, setAppScoreValue] = useState([0, 100]);
    const [allPipelinesData, setAllPipelinesData] = useState([])
    const [initialStagesLoading, setInitialStagesLoading] = useState(true)
    const [sortBy, setSortBy] = useState(() => {
        const savedView = localStorage.getItem('sortBy');
        return savedView ? JSON.parse(savedView) : "submitted_at";
    });

    const handleRangeDates = (start, end) => {
        // setDateRange(e.value);
        const formatDate = (date) => date.toLocaleDateString('en-CA');
        if (start && end) {
            let startDate = formatDate(start);
            let endDate = formatDate(end);
            let dateRangeData = `${startDate},${endDate}`;
            // setDateRangeString(dateRangeData);
            return dateRangeData
        }
    };

    const generateDateRange = () => {
        const today = new Date();
        const lastDay = new Date();
        lastDay.setDate(today.getDate() - 1);

        return handleRangeDates(lastDay, today);
    };
    // const [dates, setDates] = useState(() => generateDateRange());
    const [dateRangeString, setDateRangeString] = useState(() => generateDateRange());

    // console.log("dateRangeString", dateRangeString);

    // State for last communication filter
    const [lastCommunicationFilter, setLastCommunicationFilter] = useState({
        filter: '',
        unit: '',
        value: ''
    });

    const debouncedSearchQuery = useDebounce(searchQuery, 300);
    const debouncedIncomeRange = useDebounce(incomeRangeValue, 300);
    const debounceCreditRange = useDebounce(creditRangeValue, 300);
    const debounceSavingsRange = useDebounce(savingsRangeValue, 300);
    const debounceAppScoreRange = useDebounce(appScoreValue, 300);
    const debouncedLastCommunicationFilter = useDebounce(lastCommunicationFilter, 300);
    const [isClearingFilters, setIsClearingFilters] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [stageLoading, setStageLoading] = useState({
        "⏲️ Waiting/Follow Up": true,
        "🤳 Self-Serve Quick App": true,
        "📃✨ New Application": true,
        "🤖 Auto Doc Request": true,
        "🔥 Prequalified Awaiting Docs": true,
        "📄 Docs in - Active Client": true,
        "✅ Preapproved": true,
        "🛒Shopping": true,
        "📈 Refi": true,
        "✅ Active Loan": true
    })

    const options = ['Board', 'Hot Leads', 'Table', 'Archived'];
    const [page, setPage] = useState(table ? options[1] : options[0]);
    const op = useRef(null);
    const [total, setTotal] = useState(0);

    function getInitials(string) {
        let words = string?.split(' ');
        let initials = words?.map(word => word.charAt(0).toUpperCase());
        return initials?.join('');
    }


    const handleStageUpdate = (contact_id, form_id, stage, prevStage, emails, isLoad = false, stageId = "") => {
        const data = {
            userId: userId,
            stage_id: stageId ? stageId : stageIds[stage],
            email_list: emails
        };
        const stageUrl = `${UpdateLeadStage}${contact_id}/${form_id}`;
        axios.post(stageUrl, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Successfully Updated', life: 3000 });
                    if (isLoad) {
                        handleSearch(false);
                    }
                    setStageAppCounts(prevCounts => ({
                        ...prevCounts,
                        [stage]: prevCounts[stage] + 1,
                        [prevStage]: prevCounts[prevStage] - 1
                    }));
                    const url = `${appSubmission}${form_id}?pipelineId=${pipelineId}`;
                    axios.get(url, {
                        headers: { 'Content-Type': 'application/json' }
                    })
                        .then((response) => {
                            if (response.status === 200) {
                                const data = response.data;
                                setBoardSections(prevSections => {
                                    const updatedSections = { ...prevSections };
                                    for (const sectionId in updatedSections) {
                                        updatedSections[sectionId] = updatedSections[sectionId].map(item => {
                                            if (item.form_id === form_id) {
                                                return {
                                                    ...item,
                                                    due_date: data.due_date
                                                };
                                            }
                                            return item;
                                        });
                                    }
                                    return updatedSections;
                                });
                            }
                        });
                } else if (response.status === 208) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: response.data, life: 3000 });
                    handleSearch();
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    handleSearch();
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                handleSearch();
            });
    };

    // console.log("pipleine----------", pipeline);

    const getAllPipelines = async () => {
        if (pipelineId) {
            const url = `${getPipelines}?userId=${userId}`;
            try {
                const response = await axios.get(url, {
                    headers: { 'Content-Type': 'application/json' }
                });
                if (response.status === 200) {
                    setAllPipelinesData(response.data);
                    const item = response.data.find(item => item.id == pipelineId);
                    setPipeline(item);
                    return item;
                }
            } catch (error) {
                console.error('Error fetching pipelines:', error);
            }
        }
    };

    const getSoftwareUsersFn = () => {
        const url = `${getSoftwareUsers}`;
        axios.get(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    const options = response?.data?.map((user) => ({
                        label: user.full_name,
                        value: user.id,
                        image: user.image
                    })) || [];
                    setSoftwareUsers(options);
                }
            })
            .catch((error) => { });
    };

    async function handleSearch(isLoad = true, isClearFilters = false) {
        if (!userId || !pipelineId) {
            console.error('Missing userId or pipelineId');
            setLoading(false);
            setIsClearingFilters(false);
            return;
        }

        if (isLoad) {
            setLoading(true);
        }

        if (cancelTokenRef.current) {
            cancelTokenRef.current.cancel('Operation canceled due to new request.');
        }
        cancelTokenRef.current = CancelToken.source();

        let incomeRange = "";
        let creditRange = "";
        let savingsRange = "";
        let appScore = "";

        if (!incomeRangeValue?.includes(0) || !incomeRangeValue?.includes(2000000)) {
            incomeRange = incomeRangeValue;
        }
        if (!creditRangeValue?.includes(0) || !creditRangeValue?.includes(1000)) {
            creditRange = creditRangeValue;
        }
        if (!savingsRangeValue?.includes(0) || !savingsRangeValue?.includes(2000000)) {
            savingsRange = savingsRangeValue;
        }
        if (!appScoreValue?.includes(0) || !appScoreValue?.includes(100)) {
            appScore = appScoreValue;
        }

        const isLastCommunicationFilterValid =
            lastCommunicationFilter?.filter &&
            lastCommunicationFilter?.unit &&
            lastCommunicationFilter?.value;

        try {
            let pipelineItem = ""
            // if (isInitialLoad) {
            pipelineItem = await getAllPipelines();
            // } else {
            //     pipelineItem = pipeline
            // }

            if (!pipelineItem || !pipelineItem.stages) {
                console.error('No pipelineItem or stages found:', pipelineItem);
                setBoardSections({});
                setStageAppCounts({});
                setTotal(0);
                setStageIds({});
                setStageWatchers({});
                setLoading(false);
                setIsClearingFilters(false);
                setIsInitialLoad(false);
                return;
            }

            const pipelineStages = pipelineItem.stages.sort((a, b) => a.position - b.position);
            // console.log('pipelineStages=====', pipelineStages);

            if (!pipelineStages.length) {
                console.warn('pipelineStages is empty');
                setBoardSections({});
                setStageAppCounts({});
                setTotal(0);
                setStageIds({});
                setStageWatchers({});
                setLoading(false);
                setIsClearingFilters(false);
                setIsInitialLoad(false);
                return;
            }

            const initialBoardSections = pipelineStages.reduce((acc, stage) => {
                acc[stage.name] = [];
                return acc;
            }, {});

            pipelineStages.map(({ name }) => {
                setStageLoading(prev => ({
                    ...prev,
                    [name]: true,
                }));
            })

            setBoardSections(initialBoardSections);
            setStageAppCounts({});
            setStageIds({});
            setStageWatchers({});
            setTotal(0);

            // let isFiltersExist = selectedUsers.length || selectedApplicationByUsers.length || selectedLanguages.length || selectedLabels.length || selectedCompanies.length || searchQuery;
            let isFilters = true;
            if (isClearFilters) {
                isFilters = false;
            }
            // console.log('isFilters:', isFilters);

            const queryParams = `&search=${searchQuery}&filterUser=${selectedUsers}&applicationByUser=${selectedApplicationByUsers}&language=${selectedLanguages}&labels=${selectedLabels}&company=${selectedCompanies}&income=${incomeRange}&credit=${creditRange}&available=${savingsRange}&dateRange=${dateRangeString}&dueDateRange=${dueDateRangeString}&lastCommunicationRange=${lastCommunicationString}&appScore=${appScore}&sortBy=${sortBy}&sort=DESC&limit=10`;

            let additionalParams = "";
            if (isLastCommunicationFilterValid) {
                additionalParams = `&lastCommunicationFilter=${lastCommunicationFilter.filter}&lastCommunicationUnit=${lastCommunicationFilter.unit}&lastCommunicationValue=${lastCommunicationFilter.value}`;
            }


            const baseUrl = `${getOpportunitiesListByStage}?userId=${userId}&pipelineId=${pipelineId}&stageId=`;
            setIsClearingFilters(false);
            const counts = [];
            const promises = pipelineStages.map((stage) => {
                const stageName = stage.name;
                const stageId = stage.id;
                let url = `${baseUrl}${encodeURIComponent(stageId)}${queryParams}${additionalParams}`;

                if (!isFilters) {
                    url = `${baseUrl}${encodeURIComponent(stageId)}&sort=DESC&limit=10`;
                }
                // console.log(`API URL for stage ${stage.id} (${stage.name}):`, url);

                return axios
                    .get(url, {
                        headers: { 'Content-Type': 'application/json' },
                        cancelToken: cancelTokenRef.current.token,
                    })
                    .then((response) => {
                        if (response.status === 200) {
                            setLoading(false);
                            const stageData = response.data[stageName] || [];
                            const mappedData = Array.isArray(stageData)
                                ? stageData.map((item) => ({ ...item, id: item.form_id }))
                                : [];

                            setBoardSections((prev) => ({
                                ...prev,
                                [stageName]: mappedData,
                            }));
                            setStageAppCounts((prev) => ({
                                ...prev,
                                [stageName]: response.data.count || 0,
                            }));
                            setStageIds((prev) => ({
                                ...prev,
                                [stageName]: stageId,
                            }));
                            setStageWatchers((prev) => ({
                                ...prev,
                                [stageName]: response.data.watchers || [],
                            }));
                            counts.push(response.data.count || 0); // Collect count
                        } else {
                            console.warn(`Non-200 status for stage ${stageName}:`, response.status);
                            setBoardSections((prev) => ({ ...prev, [stageName]: [] }));
                            setStageAppCounts((prev) => ({ ...prev, [stageName]: 0 }));
                            setStageIds((prev) => ({ ...prev, [stageName]: stageId }));
                            setStageWatchers((prev) => ({ ...prev, [stageName]: [] }));
                            counts.push(0); // Push 0 for non-200 responses
                        }
                    })
                    .catch((error) => {
                        if (axios.isCancel(error)) {
                            // console.log(`Request canceled for stage ${stageName}:`, error.message);
                            counts.push(0); // Push 0 for canceled requests
                            return;
                        }
                        console.error(`Error fetching data for stage ${stageName}:`, error);
                        setBoardSections((prev) => ({ ...prev, [stageName]: [] }));
                        setStageAppCounts((prev) => ({ ...prev, [stageName]: 0 }));
                        setStageIds((prev) => ({ ...prev, [stageName]: stageId }));
                        setStageWatchers((prev) => ({ ...prev, [stageName]: [] }));
                        counts.push(0); // Push 0 for errors
                    })
                    .finally(() => {
                        setStageLoading((prev) => ({
                            ...prev,
                            [stageName]: false,
                        }));
                        setInitialStagesLoading(false)
                    });
            });

            await Promise.allSettled(promises);

            // Calculate and set total after all promises settle
            const totalCount = counts.reduce((sum, count) => sum + count, 0);
            setTotal(totalCount);

            setIsInitialLoad(false);
            // }
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('Request canceled:', error.message);
                return;
            }
            console.error('Error in handleSearch:', error);
            setBoardSections({});
            setStageAppCounts({});
            setTotal(0);
            setStageIds({});
            setStageWatchers({});
            setLoading(false);
            setIsClearingFilters(false);
            setIsInitialLoad(false);
        }
    }


    const loadUsersData = () => {
        const url = `${appKanbanUserList}?userId=${userId}`;
        axios.get(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    const options = response?.data?.map((user) => ({
                        label: user.name,
                        value: user.user_id,
                        image: user.image
                    })) || [];
                    setUsersList(options);
                }
            })
            .catch((error) => { });

        const registeredUsersUrl = `${registeredUserList}`;
        axios.get(registeredUsersUrl, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    const options = response?.data?.map((user) => ({
                        label: user.name,
                        value: user.user_id,
                        image: user.image
                    })) || [];
                    setRegisteredUsersList(options);
                }
            })
            .catch((error) => { });

        const labelsUrl = `${getLabel}`;
        axios.get(labelsUrl, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    const options = response?.data?.map((label) => ({
                        label: label.name,
                        value: label.id,
                        color: label.color
                    })) || [];
                    setLabels(options);
                }
            })
            .catch((error) => { });

        const companyUrl = `${getCompanies}`;
        axios.get(companyUrl, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    const options = response?.data?.map((option) => ({
                        label: option.title,
                        value: option.title,
                    })) || [];
                    setCompanies(options);
                }
            })
            .catch((error) => { });
    };


    // useEffect(()=> {

    // }, [isClearingFilters])

    useEffect(() => {
        if (userId && pipelineId && isInitialLoad) {
            setLoading(true);
            loadUsersData();
            getSoftwareUsersFn();
            if (userId == 99) {
                setSelectedUsers([
                    "wJkbQQbagbU6jrFgfSUl",
                    "Ifg74FqfbtWHC95uzhME",
                    "gSV6YhVq2gF8lnsHrzYP",
                    "IswqfTBczfJF7BUOm8pF",
                    "ARisaxpVQPwUnXOco19v"
                ]);
            } else if (userId == 87 || userId == 206) {
                setSelectedUsers([
                    "gSV6YhVq2gF8lnsHrzYP",
                    "TyvZ8x3ZhG8vzxmDYbk3",
                    "Mz480XDOlNyC2jK2FJGm",
                    "CqhNmmMUuVy1Eq5vHETJ",
                    "VyT8UjGuLkODwtlAmHEs",
                    "vXXIgp7pUDG6Zxl8iwlm",
                    "Ia2ZF3YDNTdmXT77CqgA",
                    "aByEKKko89e0DNiTbMez"
                ]);
            }
            handleSearch();
        }
    }, [userId, pipelineId]);

    useEffect(() => {
        if (userId && pipelineId && !isInitialLoad && !isClearingFilters) {
            setLoading(true);
            handleSearch();
            localStorage.setItem('sortBy', JSON.stringify(sortBy));
        }
    }, [userId, pipelineId, selectedUsers, selectedApplicationByUsers, selectedLanguages, selectedLabels, selectedCompanies, debouncedSearchQuery, debouncedIncomeRange, debounceCreditRange, debounceSavingsRange, debounceAppScoreRange, dateRangeString, dueDateRangeString, lastCommunicationString, isLastCommunicationFilter, isMounted, sortBy])



    // console.log("userId------", userId);
    const handleMessage = useCallback((message) => {
        try {
            console.log("message", message);
            const parsedMessage = JSON.parse(message.data);
            console.log(parsedMessage)
            handleSearch(false)
            // {
            //     "stage_id": 4,
            //     "timestamp": "2025-11-14T18:27:04.416283+00:00",
            //     "pipeline_id": 1
            // }
        } catch (error) {
            console.error('Error parsing message:', error);
        }
    }, [userId]);

    const { sendMessage, lastMessage, readyState } = useWebSocket(`wss://backendapi.homesforsalemedia.com/ws/user-pipeline/1/1/`, {
        onOpen: () => console.log('Connected to real time apps WebSocket'),
        onMessage: handleMessage,
        onClose: () => console.log('Disconnected from real time apps WebSocket'),
        onError: (error) => console.error('WebSocket error:', error),
        shouldReconnect: () => true,
        reconnectAttempts: 10,
        reconnectInterval: 3000,
    });

    return (
        <>
            <Toast ref={toast} />
            <div
                className='kanbanContainer'
                style={{
                    paddingBottom: '2rem',
                    backgroundImage: `url("${isSuperuser ? adminLogo : image}")`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    position: 'relative'
                }}
            >
                <div
                    className='table-inner-div'
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 0
                    }}
                />
                {!table && <Button className='piplelineTitleMob' style={{ cursor: "auto", color: "white", background: "transparent", boxShadow: "none", border: "none", width: "100%" }} >{pipeline.name} {!loading && `- ${total}`}</Button>}
                <FlexComponent flexDirection="column">
                    <FlexComponent className='searchContainer ' gap="2rem" justifyContent="center" style={{ margin: '10px 20px 10px 0px' }} >
                        {page === 'Board' && !table && <>
                            {<Button className='piplelineTitle' style={{ cursor: "auto", color: "white", background: "transparent", boxShadow: "none", border: "none", fontSize: "20px", fontWeight: "bold" }} >{pipeline.name} {!loading && `- ${total}`}</Button>}
                        </>}

                    </FlexComponent>
                    {page === 'Board' ? <FlexComponent flexDirection="column" className='applicant-cards' alignItems='start' gap="0.2rem" style={{ zIndex: '1' }}  >
                        <FlexComponent flexDirection='column' style={{ gap: '2rem', zIndex: '1', width: 'auto' }}>
                            <AppSectionList
                                key={loading}
                                toast={toast}
                                userId={userId}
                                pipeline={pipeline}
                                allPipelinesData={allPipelinesData}
                                softwareUsers={softwareUsers}
                                usersList={registeredUsersList}
                                setTotal={setTotal}
                                language={selectedLanguages}
                                labels={selectedLabels}
                                dateRange={dateRangeString}
                                dueDateRange={dueDateRangeString}
                                lastCommunicationRange={lastCommunicationString}
                                lastCommunicationFilter={lastCommunicationFilter}
                                companies={selectedCompanies}
                                incomeRangeValue={incomeRangeValue}
                                creditRangeValue={creditRangeValue}
                                savingsRangeValue={savingsRangeValue}
                                appScoreValue={appScoreValue}
                                stageAppCounts={stageAppCounts}
                                stageIds={stageIds}
                                stageWatchers={stageWatchers}
                                setStageAppCounts={setStageAppCounts}
                                selectedUsers={selectedUsers}
                                selectedApplicationByUsers={selectedApplicationByUsers}
                                boardSections={boardSections}
                                setBoardSections={setBoardSections}
                                handleStageUpdate={handleStageUpdate}
                                searchQuery={searchQuery}
                                sortBy={sortBy}
                                isMounted={isMounted}
                                setIsMounted={setIsMounted}
                                loading={loading}
                                stageLoading={stageLoading}
                                loadStageId = {4}
                            />
                        </FlexComponent>
                    </FlexComponent>
                        : page === 'Hot Leads' ?
                            <AppsTable userId={userId} isHotLeads={true} />
                            : page === 'Table' ?
                                <AppsTable userId={userId} />
                                : <ArchivedAppsTable userId={userId} />
                    }
                </FlexComponent>
            </div>
        </>
    );
};

export default RealTimeAppsKanban;